export const SEO_MEO_PACK_TRAIN_PERIOD = '2年間'

export const isSeoMeoPackActive = () => {
  const el = document.querySelector('#formSeoMeoPackSelect')
  return !!(el && el.checked)
}

/** データ編集画面のシート転記用（申込送信は seo.class.js の type_num 経由） */
export const getSeoTypeNumForSheet = () => {
  if (!isSeoMeoPackActive()) return ''
  const el = document.querySelector('input[name="seo_meo_pack_plan"]:checked')
  return el ? el.value : ''
}

export const SEO_MEO_PACK_PLANS = {
  'ライトプラン': {},
  'スタンダードプラン': {},
  'エリア拡大プラン': {},
}

export const applySeoMeoPackTrainPeriodLock = ($) => {
  $('.js-seo-train-period, .js-meo-train-period').show()
  $('#seoTrain2, #meoTrain2').prop('checked', true)
  $('input[name="seo_train"], input[name="meo_train"]')
    .prop('disabled', true)
    .removeClass('required')
}

export const resetSeoMeoPackTrainPeriodLock = ($) => {
  $('input[name="seo_train"], input[name="meo_train"]')
    .prop('disabled', false)
    .addClass('required')
    .prop('checked', false)
}

class afrPostSeoMeoPack {
  constructor(that) {
    this.that = that
    this.formName = 'SEO・MEO集客最大化パック'
    this.that.$('.search_form_wrap').show()
  }

  returnFormName() {
    return this.formName
  }

  getInputData() {
    const $ = this.that.$
    const store = this.that.store

    const plan = $('input[name="seo_meo_pack_plan"]:checked').val() || ''

    store.commit('setValue', ['seoMeoPack', 'plan', plan, 'plan'])
  }

  setVal() {
    const store = this.that.store
    const data = store.state.formData.seoMeoPack

    const sendVal =
`
◎SEO・MEO集客最大化パック
プラン：${data.plan}
`
    store.commit('setTalknoteMessage', ['seoMeoPack', sendVal])
  }
}

export default {
  afrPostSeoMeoPack,
}
